import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

const DlGroupList: React.FC = () => {
  return (
    <Content>
      <ContentInner>
        <NewItem>
          <RouterLink to="/admin-dashboard/dl-group-edit">novo</RouterLink>
        </NewItem>

        {[
          "petar-lubarda",
          "nadezda-petrovic",
          "muzej-savremene-umetnosti",
          "avangarda",
          "sava-sumanovic",
          "test1",
          "oktobarski-salon",
        ].map((item) => (
          <ListItem key={item}>
            <RouterLink to={`/admin-dashboard/dl-group-edit/${item}`}>
              polja
            </RouterLink>
            <br />
            {item.replace(/-/g, " ")}
            <DeleteText>obriši</DeleteText>
          </ListItem>
        ))}
      </ContentInner>
    </Content>
  );
};

export default DlGroupList;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteText = styled.span`
  margin-left: 3%;
  cursor: pointer;
  color: darkgrey;
`;
